import { render, staticRenderFns } from "./InfoDrawer.vue?vue&type=template&id=6fb32b38&scoped=true"
import script from "./InfoDrawer.vue?vue&type=script&lang=js"
export * from "./InfoDrawer.vue?vue&type=script&lang=js"
import style0 from "./InfoDrawer.vue?vue&type=style&index=0&id=6fb32b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb32b38",
  null
  
)

export default component.exports